var _clipPath;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 170 120",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "git.c60b7e5ae8ec2562f23fdddcab300026.svg",
    transform: "matrix(0.0451127,0,0,0.0451127,85.1186,59.7481)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1250,-1250)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2500,
    height: 2500
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2452.85,1138.61L1361.33,47.148C1298.51,-15.713 1196.55,-15.713 1133.65,47.148L906.992,273.809L1194.52,561.338C1261.34,538.76 1337.96,553.906 1391.22,607.168C1444.74,660.771 1459.78,738.047 1436.65,805.078L1713.75,1082.19C1780.79,1059.09 1858.14,1074.03 1911.69,1127.67C1986.52,1202.47 1986.52,1323.71 1911.69,1398.56C1836.84,1473.43 1715.6,1473.43 1640.7,1398.56C1584.41,1342.22 1570.51,1259.55 1599,1190.2L1340.59,931.787L1340.56,1611.84C1359.29,1621.1 1376.4,1633.33 1391.22,1648.07C1466.06,1722.87 1466.06,1844.12 1391.22,1919.03C1316.37,1993.86 1195.07,1993.86 1120.32,1919.03C1045.49,1844.12 1045.49,1722.88 1120.32,1648.08C1138.26,1630.13 1159.57,1615.92 1183.03,1606.27L1183.03,919.883C1159.54,910.293 1138.21,896.074 1120.32,878.076C1063.62,821.455 1049.99,738.262 1079.04,668.643L795.605,385.176L47.168,1133.56C-15.723,1196.48 -15.723,1298.45 47.168,1361.32L1138.71,2452.8C1201.55,2515.67 1303.49,2515.67 1366.41,2452.8L2452.84,1366.39C2515.71,1303.5 2515.71,1201.48 2452.84,1138.61",
    style: {
      fill: "rgb(222,76,54)",
      fillRule: "nonzero"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.30537001b98df0623adca37f93ddce68.svg";
export { ForwardRef as ReactComponent };